import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import Loader from "@/components/Loader/LoaderView";

import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import { client_domain } from "@/main.js";

export default {
  components: {
    Sidebar,
    Navbar,
    Loader
  },
  data() {
    return ({
      isSubmitting: false,
      members: [],
      verifiedMember: [],
      rsvp_code: '',
      message: '',
      isVerified: false,
      errors: {},
      cbo_domain: false,
      user_details: {
        user_role: ''
      },
    });
  },
  methods: {
    getToken() {
      return get_token();
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },
    exportToCSV() {
      const table = $('.table').DataTable();
      const filteredData = table.rows({ search: 'applied' }).data();

      if (!filteredData || filteredData.length === 0) {
        Swal.fire({
          icon: 'warning',
          text: 'No members to export.',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }
 
      const is_cbo = this.cbo_domain; // Assuming this.cbo_domain is reactive
 
      let csvHeader = "First Name,Last Name,Email,Phone Number,Event";
      if (is_cbo) {
        csvHeader += ",Business Name,First Time Attending,Chapter";
      }
      csvHeader += ",Meal\n";
 
      const csvRows = this.members.map(user => {
        const firstName = user.user?.first_name || "";
        const lastName = user.user?.last_name || "";
        const email = user.user?.email || "";
        const phoneNumber = user.user?.phone_number || "";
        const eventName = user?.event_name || "";
        const meals = user.rsvp_items?.map(item => item.item?.item_name).join(", ") || "";
 
        let row = `${firstName},${lastName},${email},${phoneNumber},${eventName}`;
 
        if (is_cbo) {
          const business_name = user.business_name || "";
          const first_time = user.is_first_time ? "Yes" : "No";
          const chapter = user.chapter || "";
          row += `,${business_name},${first_time},${chapter}`;
        }
 
        row += `,"${meals}"`;
 
        return row;
      });
 
      const csvContent = csvHeader + csvRows.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
 
      const a = document.createElement("a");
      a.href = url;
      a.download = "rsvp members.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },

    filterRSVP() {
      const event_id = this.$route.params.event_id || null;
      this.isSubmitting = true;
      return new Promise((resolve) => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_rsvp/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({ event_id }),
          success: (data) => {
            this.members = data.rsvp_data;
            this.isSubmitting = false;
            resolve();
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      });
    },
    verifyRsvpCode() {
      this.isSubmitting = true;
      const formData = new FormData();
      if (!this.rsvp_code) {
        this.message = 'RSVP Code is required';
        return;
      }
      formData.append('provided_rsvp_code', this.rsvp_code);
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/verify_rsvp_code/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          const status = response.status
          this.isVerified = true;
          this.verifiedMember = response.rsvp_data
          this.message = "RSVP code verified!"
          if (status === "success") {
            Swal.fire({
              icon: 'success',
              title: this.message,
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            })
          }
        },
        error: (response) => {
          this.isVerified = false;
          Swal.close();
          const response_data = response.responseJSON;
          this.message = response_data.message
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },

    cancelRSVP(event_id, user_id = null) {
      const token = this.getToken();


      if (!Number.isInteger(event_id)) {
        Swal.fire({
          title: 'Invalid ID',
          text: 'The event ID is not valid.',
          icon: 'error',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }

      const payload = { event_id }
      if (this.user_details.user_role === 'admin' && user_id) {
        payload.user_id = user_id
      }

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/cancel_rsvp/`,
        contentType: 'application/json',
        data: JSON.stringify(payload),
        headers: {
          'Authorization': `Token ${token}`
        },
        success: (data) => {
          if (data.status === 'success') {

            Swal.fire({
              icon: 'success',
              title: 'RSVP Cancelled',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              this.members = this.members.filter(member => member.user.id !== user_id);
              Swal.close();
            })
          } else {
            Swal.fire({
              title: 'Error',
              text: data.message || 'Cancel failed',
              icon: 'error',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        },
        error: (xhr) => {
          const response = xhr.responseJSON || {};
          Swal.fire({
            title: 'Error',
            text: response.message || 'Something went wrong',
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },
    resetForm() {
      this.rsvp_code = '';
      this.message = '';
      this.isVerified = false;
      this.verifiedMember = null;
    },
  },
  mounted() {
    this.user_details = get_user_details();
    this.filterRSVP().then(() => {
      this.$nextTick(() => {
        $('.table').DataTable({
          paging: true,
          searching: true,
          ordering: true,
          info: true,
          lengthChange: true,
          pageLength: 10,
          language: {
            paginate: {
              previous: "Previous",
              next: "Next"
            },
            info: "Showing _START_ to _END_ of _TOTAL_ entries",
            infoEmpty: "No entries available"
          },
          sortColumn: '',
          sortDirection: 'asc'
        });
      });
    });
    if (client_domain.includes('cbo')) {
      this.cbo_domain = true;
    }
  }
};
